/* Continuidad del mosaico de una sección a la siguiente.
 *
 * Cada sección pinta su propia capa de patrón, y `background-repeat` empieza a
 * contar desde el borde de arriba de esa capa. Como las secciones no miden lo
 * mismo, el mosaico arrancaba de cero en cada una: al pasar de una a otra los
 * sobres se cortaban a media altura y la rejilla saltaba. Se nota justo en la
 * frontera, que es donde el fondo cambia de color y el ojo va solo.
 *
 * Esto le da a todas las capas el mismo origen: el principio del documento. A
 * cada una se le resta lo que le sobra —el resto de dividir su posición entre
 * el alto del motivo— y la rejilla sigue de arriba abajo de la página, aunque
 * cada sección tenga su color y su intensidad.
 *
 * En horizontal no hace falta nada: todas las capas van a lo ancho de la página
 * y con `background-position-x: center`, así que ya comparten fase.
 *
 * Sin JavaScript no se rompe nada: se ve como se veía antes, con el mosaico
 * empezando en cada sección.
 */
(function () {
  'use strict';

  // Solo las capas a sangre. Los paneles del 404 y de la página de gracias son
  // cajas sueltas: ahí el mosaico es del panel, no del fondo, y alinearlo con
  // el resto no significaría nada. Desde T2.42 el mosaico de la portada vive
  // en «Avísame» y en el pie, que van seguidos: los dos llevan
  // `data-aru-mosaico` para que la rejilla no se corte al pasar de uno a otro.
  var CAPAS = '.section > .aru-pattern, [data-aru-mosaico] > .aru-pattern';
  var proporciones = {};    // url -> alto/ancho del motivo

  function url(capa) {
    var crudo = getComputedStyle(capa).getPropertyValue('--aru-pattern-image');
    var m = crudo.match(/url\(\s*(['"]?)(.*?)\1\s*\)/);
    return m ? m[2] : '';
  }

  /* `background-size` es `<lado> auto`, así que el alto del motivo depende de
     la proporción del fichero. Con el patrón del tema es cuadrado, pero desde
     el panel se puede subir otro y entonces el alto ya no es el lado. */
  function conProporcion(fuente, sigue) {
    if (fuente in proporciones) return sigue(proporciones[fuente]);
    var img = new Image();
    img.onload = function () {
      proporciones[fuente] = img.naturalWidth ? img.naturalHeight / img.naturalWidth : 1;
      sigue(proporciones[fuente]);
    };
    img.onerror = function () {
      proporciones[fuente] = 1;
      sigue(1);
    };
    img.src = fuente;
  }

  function alinear() {
    var capas = document.querySelectorAll(CAPAS);
    var desplazada = window.scrollY || window.pageYOffset || 0;
    for (var i = 0; i < capas.length; i++) {
      (function (capa) {
        var lado = parseFloat(getComputedStyle(capa).getPropertyValue('--aru-pattern-size'));
        if (!lado || lado <= 0) return;
        var arriba = capa.getBoundingClientRect().top + desplazada;
        conProporcion(url(capa), function (proporcion) {
          var alto = lado * proporcion;
          if (!alto || alto <= 0) return;
          var sobra = arriba % alto;
          if (sobra < 0) sobra += alto;
          capa.style.backgroundPositionY = (-sobra).toFixed(2) + 'px';
          // Para tools/prueba-patron.py, que si no tendría que volver a
          // adivinar el alto del motivo por su cuenta.
          capa.dataset.aruMotivo = alto.toFixed(2);
        });
      })(capas[i]);
    }
  }

  var pendiente = null;
  function replantear() {
    if (pendiente !== null) return;
    pendiente = window.requestAnimationFrame(function () {
      pendiente = null;
      alinear();
    });
  }

  alinear();
  // Las alturas cambian con el ancho de la ventana y cuando entra la tipografía
  // de verdad: un titular que pasa de dos líneas a tres mueve todo lo de abajo.
  window.addEventListener('resize', replantear);
  window.addEventListener('orientationchange', replantear);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(replantear);
  if (window.ResizeObserver) new ResizeObserver(replantear).observe(document.body);
})();
